module.exports = __webpack_public_path__ + "img/eth.4c22c34b.png";